// All translations for Ragi chrome + hero + CTAs.
// Long-form editorial content stays in English for now (RTL/CJK will render fine
// but page bodies remain in English until per-locale copy is authored).

const en = {
  meta: {
    title: "Ragi | Design that moves businesses forward.",
    description:
      "Senior-led branding, digital and packaging design for ambitious businesses. From Bengaluru, worldwide.",
  },
  nav: {
    work: "Work",
    cases: "Case Studies",
    services: "Services",
    industries: "Industries",
    about: "About",
    founder: "Founder",
    insights: "Insights",
    blog: "Blog",
    qa: "Q&A",
    contact: "Contact",
    startProject: "Start a Project",
    menuOpen: "Open menu",
    menuClose: "Close menu",
    navigate: "Navigate",
    allServices: "All services",
    allIndustries: "All industries",
    studioBengaluru: "Studio · Bengaluru",
    call: "Call",
    whatsapp: "WhatsApp",
    email: "Email",
    bookMeeting: "Book a 60-min meeting",
    signature: "Design that moves businesses forward.",
  },
  hero: {
    line1: "Design That Builds Brands",
    line2: "and Moves Businesses",
    line3: "Forward.",
    eyebrow: "RAGI · Global Design & Growth Partner",
    subEyebrow: "Based in Bengaluru · Working globally",
    subline: "RAGI helps ambitious businesses build stronger brands, better digital experiences and powerful communication through strategy, design and business thinking.",
    ctaPrimary: "View Our Work",
    ctaSecondary: "Start a Project",
    proofEyebrow: "Experience you can build on",
    proofLine: "15+ Years. 600+ Brands.",
    proofLineHighlight: "20,000+",
    proofLineTail: "Creative Projects.",
    scroll: "Scroll",
    tags: { brand: "Brand System", packaging: "Packaging", digital: "Digital Product" },
  },
  cta: {
    eyebrow: "Have a business challenge?",
    title1: "Let's build the right",
    title2: "solution.",
    subline: "Whether you're launching, repositioning or preparing for the next stage of growth, RAGI can help build the creative foundation.",
    start: "Start a Project",
    call: "Call {{phone}}",
    book: "Book a Consultation",
  },
  footer: {
    tagline: "Global Design & Growth Partner. Senior-led from Bengaluru. Working worldwide.",
    subscribePlaceholder: "Your email, for occasional letters on design and business",
    subscribe: "Subscribe →",
    sending: "Sending",
    explore: "Explore",
    services: "Services",
    studio: "Studio",
    social: "Social",
    allServicesLink: "All services",
    privacy: "Privacy",
    terms: "Terms",
    sitemap: "Sitemap",
    rights: "All rights reserved.",
  },
  toast: {
    subscribed: "Subscribed. We'll be in touch.",
    subscribeError: "Could not subscribe right now. Please try again.",
    contactSuccess: "Thank you. We will respond within one business day.",
    contactError: "Could not send your enquiry right now. Please try email or WhatsApp.",
    invalidEmail: "Please enter a valid email.",
    fillRequired: "Please fill in name, email and message.",
  },
  language: {
    label: "Language",
    switchTo: "Switch language",
  },
};

const es = {
  meta: {
    title: "Ragi | Diseño que impulsa negocios.",
    description:
      "Branding, diseño digital y packaging liderados por sénior para empresas ambiciosas. Desde Bengaluru, en todo el mundo.",
  },
  nav: {
    work: "Proyectos", cases: "Casos", services: "Servicios", industries: "Industrias",
    about: "Nosotros", founder: "Fundador", insights: "Ideas", contact: "Contacto",
    startProject: "Iniciar Proyecto", menuOpen: "Abrir menú", menuClose: "Cerrar menú",
    navigate: "Navegar", allServices: "Todos los servicios", allIndustries: "Todas las industrias",
    studioBengaluru: "Estudio · Bengaluru", call: "Llamar", whatsapp: "WhatsApp",
    email: "Correo", bookMeeting: "Reservar reunión de 60 min",
    signature: "Diseño que impulsa negocios.",
  },
  hero: {
    line1: "Diseño que", line2: "Impulsa Negocios", line3: "Adelante.",
    eyebrow: "Ragi · Fundado en Bengaluru",
    subEyebrow: "Un equipo de diseño senior",
    subline: "Marca, digital y packaging, a cargo de un solo equipo senior.",
    ctaPrimary: "Ver Proyectos", ctaSecondary: "Iniciar Proyecto",
    proofEyebrow: "Datos, no adjetivos",
    proofLine: "16 años. 600+ marcas.",
    proofLineHighlight: "20.000+", proofLineTail: "proyectos creativos.",
    scroll: "Desliza",
    tags: { brand: "Sistema de Marca", packaging: "Packaging", digital: "Producto Digital" },
  },
  cta: {
    eyebrow: "Iniciar un proyecto", title1: "Un brief. Una idea.",
    title2: "Un problema que vale resolver.",
    subline: "Respuesta en un día. Llamada de 60 minutos.",
    start: "Iniciar Proyecto", call: "Llamar {{phone}}", book: "Reservar reunión de 60 min",
  },
  footer: {
    tagline: "Diseño sénior. Trabajo global. Desde Bengaluru.",
    subscribePlaceholder: "Tu email · cartas ocasionales sobre diseño y negocios",
    subscribe: "Suscribir →", sending: "Enviando",
    explore: "Explorar", services: "Servicios", studio: "Estudio", social: "Redes",
    allServicesLink: "Todos los servicios",
    privacy: "Privacidad", terms: "Términos", sitemap: "Mapa del sitio",
    rights: "Todos los derechos reservados.",
  },
  toast: {
    subscribed: "Suscrito. Te contactaremos.",
    subscribeError: "No pudimos suscribirte. Intenta de nuevo.",
    contactSuccess: "Gracias. Responderemos en un día hábil.",
    contactError: "No pudimos enviar tu consulta. Prueba email o WhatsApp.",
    invalidEmail: "Introduce un email válido.",
    fillRequired: "Rellena nombre, email y mensaje.",
  },
  language: { label: "Idioma", switchTo: "Cambiar idioma" },
};

const fr = {
  meta: {
    title: "Ragi | Un design qui fait avancer les entreprises.",
    description:
      "Branding, design digital et packaging menés par des seniors pour des entreprises ambitieuses. Depuis Bengaluru, partout dans le monde.",
  },
  nav: {
    work: "Travaux", cases: "Études de cas", services: "Services", industries: "Secteurs",
    about: "À propos", founder: "Fondateur", insights: "Idées", contact: "Contact",
    startProject: "Démarrer un projet", menuOpen: "Ouvrir le menu", menuClose: "Fermer le menu",
    navigate: "Naviguer", allServices: "Tous les services", allIndustries: "Tous les secteurs",
    studioBengaluru: "Studio · Bengaluru", call: "Appeler", whatsapp: "WhatsApp",
    email: "E-mail", bookMeeting: "Réserver un appel de 60 min",
    signature: "Un design qui fait avancer les entreprises.",
  },
  hero: {
    line1: "Un design qui", line2: "Fait avancer les", line3: "Entreprises.",
    eyebrow: "Ragi · Fondé à Bengaluru",
    subEyebrow: "Une équipe de design senior",
    subline: "Marque, digital et packaging, pris en charge par une seule équipe senior.",
    ctaPrimary: "Voir les travaux", ctaSecondary: "Démarrer un projet",
    proofEyebrow: "Des faits, pas des adjectifs",
    proofLine: "16 ans. 600+ marques.",
    proofLineHighlight: "20 000+", proofLineTail: "projets créatifs.",
    scroll: "Défiler",
    tags: { brand: "Système de marque", packaging: "Packaging", digital: "Produit digital" },
  },
  cta: {
    eyebrow: "Démarrer un projet", title1: "Un brief. Une idée.",
    title2: "Un problème à résoudre.",
    subline: "Réponse en un jour. Appel de 60 minutes.",
    start: "Démarrer un projet", call: "Appeler {{phone}}", book: "Réserver un appel de 60 min",
  },
  footer: {
    tagline: "Design senior. Travail global. Depuis Bengaluru.",
    subscribePlaceholder: "Votre e-mail · lettres occasionnelles sur design et business",
    subscribe: "S'abonner →", sending: "Envoi",
    explore: "Explorer", services: "Services", studio: "Studio", social: "Réseaux",
    allServicesLink: "Tous les services",
    privacy: "Confidentialité", terms: "Conditions", sitemap: "Plan du site",
    rights: "Tous droits réservés.",
  },
  toast: {
    subscribed: "Inscrit. Nous vous recontacterons.",
    subscribeError: "Impossible pour le moment. Réessayez.",
    contactSuccess: "Merci. Réponse sous un jour ouvré.",
    contactError: "Impossible d'envoyer votre demande. Essayez e-mail ou WhatsApp.",
    invalidEmail: "E-mail invalide.",
    fillRequired: "Remplissez nom, e-mail et message.",
  },
  language: { label: "Langue", switchTo: "Changer de langue" },
};

const de = {
  meta: {
    title: "Ragi | Design, das Unternehmen voranbringt.",
    description:
      "Senior-geführtes Branding, digitales Design und Verpackung für ambitionierte Unternehmen. Aus Bengaluru, weltweit.",
  },
  nav: {
    work: "Arbeiten", cases: "Fallstudien", services: "Leistungen", industries: "Branchen",
    about: "Über uns", founder: "Gründer", insights: "Einsichten", contact: "Kontakt",
    startProject: "Projekt starten", menuOpen: "Menü öffnen", menuClose: "Menü schließen",
    navigate: "Navigation", allServices: "Alle Leistungen", allIndustries: "Alle Branchen",
    studioBengaluru: "Studio · Bengaluru", call: "Anrufen", whatsapp: "WhatsApp",
    email: "E-Mail", bookMeeting: "60-Min-Meeting buchen",
    signature: "Design, das Unternehmen voranbringt.",
  },
  hero: {
    line1: "Design, das", line2: "Unternehmen", line3: "Voranbringt.",
    eyebrow: "Ragi · Est. Bengaluru",
    subEyebrow: "Ein erfahrenes Designteam",
    subline: "Marke, Digital und Verpackung, aus einer Hand von einem erfahrenen Team.",
    ctaPrimary: "Ausgewählte Arbeiten", ctaSecondary: "Projekt starten",
    proofEyebrow: "Fakten, keine Adjektive",
    proofLine: "16 Jahre. 600+ Marken.",
    proofLineHighlight: "20.000+", proofLineTail: "Kreativprojekte.",
    scroll: "Scrollen",
    tags: { brand: "Markensystem", packaging: "Verpackung", digital: "Digitales Produkt" },
  },
  cta: {
    eyebrow: "Projekt starten", title1: "Ein Brief. Eine Idee.",
    title2: "Ein Problem, das es zu lösen lohnt.",
    subline: "Antwort in einem Tag. 60-Minuten-Intro.",
    start: "Projekt starten", call: "Anrufen {{phone}}", book: "60-Min-Meeting buchen",
  },
  footer: {
    tagline: "Senior-Design. Globale Arbeit. Aus Bengaluru.",
    subscribePlaceholder: "Ihre E-Mail · gelegentliche Briefe zu Design und Business",
    subscribe: "Abonnieren →", sending: "Sendet",
    explore: "Entdecken", services: "Leistungen", studio: "Studio", social: "Social",
    allServicesLink: "Alle Leistungen",
    privacy: "Datenschutz", terms: "AGB", sitemap: "Sitemap",
    rights: "Alle Rechte vorbehalten.",
  },
  toast: {
    subscribed: "Abonniert. Wir melden uns.",
    subscribeError: "Abonnement fehlgeschlagen. Bitte erneut versuchen.",
    contactSuccess: "Danke. Antwort innerhalb eines Werktages.",
    contactError: "Anfrage konnte nicht gesendet werden. Bitte E-Mail oder WhatsApp.",
    invalidEmail: "Gültige E-Mail eingeben.",
    fillRequired: "Name, E-Mail und Nachricht ausfüllen.",
  },
  language: { label: "Sprache", switchTo: "Sprache ändern" },
};

const pt = {
  meta: {
    title: "Ragi | Design que move negócios.",
    description:
      "Branding, design digital e packaging liderados por sênior para empresas ambiciosas. De Bengaluru, para o mundo.",
  },
  nav: {
    work: "Projetos", cases: "Casos", services: "Serviços", industries: "Indústrias",
    about: "Sobre", founder: "Fundador", insights: "Insights", contact: "Contato",
    startProject: "Iniciar Projeto", menuOpen: "Abrir menu", menuClose: "Fechar menu",
    navigate: "Navegar", allServices: "Todos os serviços", allIndustries: "Todas as indústrias",
    studioBengaluru: "Estúdio · Bengaluru", call: "Ligar", whatsapp: "WhatsApp",
    email: "E-mail", bookMeeting: "Agendar reunião de 60 min",
    signature: "Design que move negócios.",
  },
  hero: {
    line1: "Design que", line2: "Move Negócios", line3: "Adiante.",
    eyebrow: "Ragi · Sediado em Bengaluru",
    subEyebrow: "Uma equipa de design sénior",
    subline: "Marca, digital e packaging, tratados por uma única equipa sénior.",
    ctaPrimary: "Ver Projetos", ctaSecondary: "Iniciar Projeto",
    proofEyebrow: "Fatos, não adjetivos",
    proofLine: "16 anos. 600+ marcas.",
    proofLineHighlight: "20.000+", proofLineTail: "projetos criativos.",
    scroll: "Rolar",
    tags: { brand: "Sistema de Marca", packaging: "Packaging", digital: "Produto Digital" },
  },
  cta: {
    eyebrow: "Iniciar um projeto", title1: "Um brief. Uma ideia.",
    title2: "Um problema que vale resolver.",
    subline: "Resposta em um dia. Chamada de 60 minutos.",
    start: "Iniciar Projeto", call: "Ligar {{phone}}", book: "Agendar reunião de 60 min",
  },
  footer: {
    tagline: "Design sênior. Trabalho global. De Bengaluru.",
    subscribePlaceholder: "Seu e-mail · cartas ocasionais sobre design e negócios",
    subscribe: "Inscrever →", sending: "Enviando",
    explore: "Explorar", services: "Serviços", studio: "Estúdio", social: "Redes",
    allServicesLink: "Todos os serviços",
    privacy: "Privacidade", terms: "Termos", sitemap: "Mapa do site",
    rights: "Todos os direitos reservados.",
  },
  toast: {
    subscribed: "Inscrito. Entraremos em contato.",
    subscribeError: "Não foi possível inscrever. Tente novamente.",
    contactSuccess: "Obrigado. Responderemos em um dia útil.",
    contactError: "Não foi possível enviar. Tente e-mail ou WhatsApp.",
    invalidEmail: "Digite um e-mail válido.",
    fillRequired: "Preencha nome, e-mail e mensagem.",
  },
  language: { label: "Idioma", switchTo: "Mudar idioma" },
};

const it = {
  meta: {
    title: "Ragi | Design che fa muovere il business.",
    description: "Branding, design digitale e packaging guidati da senior per aziende ambiziose. Da Bengaluru, nel mondo.",
  },
  nav: {
    work: "Lavori", cases: "Casi studio", services: "Servizi", industries: "Settori",
    about: "Chi siamo", founder: "Fondatore", insights: "Idee", contact: "Contatti",
    startProject: "Avvia progetto", menuOpen: "Apri menu", menuClose: "Chiudi menu",
    navigate: "Naviga", allServices: "Tutti i servizi", allIndustries: "Tutti i settori",
    studioBengaluru: "Studio · Bengaluru", call: "Chiama", whatsapp: "WhatsApp",
    email: "E-mail", bookMeeting: "Prenota call di 60 min",
    signature: "Design che fa muovere il business.",
  },
  hero: {
    line1: "Design che", line2: "Fa muovere il", line3: "Business.",
    eyebrow: "Ragi · Sede a Bengaluru",
    subEyebrow: "Un team di design senior",
    subline: "Brand, digitale e packaging, gestiti da un unico team senior.",
    ctaPrimary: "Vedi i lavori", ctaSecondary: "Avvia progetto",
    proofEyebrow: "Fatti, non aggettivi",
    proofLine: "16 anni. 600+ marchi.",
    proofLineHighlight: "20.000+", proofLineTail: "progetti creativi.",
    scroll: "Scorri",
    tags: { brand: "Sistema di brand", packaging: "Packaging", digital: "Prodotto digitale" },
  },
  cta: {
    eyebrow: "Avvia un progetto", title1: "Un brief. Un'idea.",
    title2: "Un problema da risolvere.",
    subline: "Risposta in un giorno. Call di 60 minuti.",
    start: "Avvia progetto", call: "Chiama {{phone}}", book: "Prenota call di 60 min",
  },
  footer: {
    tagline: "Design senior. Lavoro globale. Da Bengaluru.",
    subscribePlaceholder: "La tua e-mail · lettere occasionali su design e business",
    subscribe: "Iscriviti →", sending: "Invio",
    explore: "Esplora", services: "Servizi", studio: "Studio", social: "Social",
    allServicesLink: "Tutti i servizi",
    privacy: "Privacy", terms: "Termini", sitemap: "Mappa del sito",
    rights: "Tutti i diritti riservati.",
  },
  toast: {
    subscribed: "Iscritto. Ti contatteremo.",
    subscribeError: "Iscrizione non riuscita. Riprova.",
    contactSuccess: "Grazie. Risposta entro un giorno lavorativo.",
    contactError: "Invio non riuscito. Prova e-mail o WhatsApp.",
    invalidEmail: "Inserisci un'e-mail valida.",
    fillRequired: "Compila nome, e-mail e messaggio.",
  },
  language: { label: "Lingua", switchTo: "Cambia lingua" },
};

const ar = {
  meta: {
    title: "‏Ragi | تصميم يدفع الأعمال إلى الأمام.",
    description: "‏تصميم علامات تجارية ومنتجات رقمية وعبوات بقيادة كبار المصممين للشركات الطموحة. من بنغالورو إلى العالم.",
  },
  nav: {
    work: "الأعمال", cases: "دراسات الحالة", services: "الخدمات", industries: "الصناعات",
    about: "من نحن", founder: "المؤسس", insights: "أفكار", contact: "تواصل",
    startProject: "ابدأ مشروعًا", menuOpen: "افتح القائمة", menuClose: "أغلق القائمة",
    navigate: "تصفح", allServices: "كل الخدمات", allIndustries: "كل الصناعات",
    studioBengaluru: "الاستوديو · بنغالورو", call: "اتصل", whatsapp: "واتساب",
    email: "بريد", bookMeeting: "احجز مكالمة 60 دقيقة",
    signature: "تصميم يدفع الأعمال إلى الأمام.",
  },
  hero: {
    line1: "تصميم", line2: "يدفع الأعمال", line3: "إلى الأمام.",
    eyebrow: "Ragi · من بنغالورو",
    subEyebrow: "فريق تصميم واحد رفيع الخبرة",
    subline: "العلامة التجارية والرقمي والتغليف، بإدارة فريق واحد رفيع الخبرة.",
    ctaPrimary: "أعمال مختارة", ctaSecondary: "ابدأ مشروعًا",
    proofEyebrow: "حقائق لا صفات",
    proofLine: "16 سنة. أكثر من 600 علامة.",
    proofLineHighlight: "+20,000", proofLineTail: "مشروع إبداعي.",
    scroll: "مرّر",
    tags: { brand: "نظام علامة", packaging: "تغليف", digital: "منتج رقمي" },
  },
  cta: {
    eyebrow: "ابدأ مشروعًا", title1: "فكرة. مشروع.",
    title2: "مشكلة تستحق الحل.",
    subline: "رد خلال يوم. مكالمة 60 دقيقة.",
    start: "ابدأ مشروعًا", call: "اتصل {{phone}}", book: "احجز مكالمة 60 دقيقة",
  },
  footer: {
    tagline: "تصميم بقيادة كبار. أعمال عالمية. من بنغالورو.",
    subscribePlaceholder: "بريدك · رسائل من حين لآخر عن التصميم والأعمال",
    subscribe: "اشترك →", sending: "جارٍ الإرسال",
    explore: "استكشف", services: "الخدمات", studio: "الاستوديو", social: "تواصل اجتماعي",
    allServicesLink: "كل الخدمات",
    privacy: "الخصوصية", terms: "الشروط", sitemap: "خريطة الموقع",
    rights: "جميع الحقوق محفوظة.",
  },
  toast: {
    subscribed: "تم الاشتراك. سنتواصل معك.",
    subscribeError: "تعذر الاشتراك. حاول مجددًا.",
    contactSuccess: "شكرًا. سنرد خلال يوم عمل.",
    contactError: "تعذر إرسال الاستفسار. جرّب البريد أو واتساب.",
    invalidEmail: "أدخل بريدًا صحيحًا.",
    fillRequired: "أكمل الاسم والبريد والرسالة.",
  },
  language: { label: "اللغة", switchTo: "غيّر اللغة" },
};

const zh = {
  meta: {
    title: "Ragi | 推动商业前行的设计。",
    description: "由资深设计师主导的品牌、数字和包装设计，服务于有雄心的企业。源自班加罗尔，服务全球。",
  },
  nav: {
    work: "作品", cases: "案例", services: "服务", industries: "行业",
    about: "关于", founder: "创始人", insights: "洞察", contact: "联系",
    startProject: "开始项目", menuOpen: "打开菜单", menuClose: "关闭菜单",
    navigate: "导航", allServices: "所有服务", allIndustries: "所有行业",
    studioBengaluru: "工作室 · 班加罗尔", call: "致电", whatsapp: "WhatsApp",
    email: "邮件", bookMeeting: "预约60分钟会议",
    signature: "推动商业前行的设计。",
  },
  hero: {
    line1: "推动商业", line2: "前行的", line3: "设计。",
    eyebrow: "Ragi · 创立于班加罗尔",
    subEyebrow: "一个资深设计团队",
    subline: "品牌、数字与包装设计，由同一个资深团队负责。",
    ctaPrimary: "查看作品", ctaSecondary: "开始项目",
    proofEyebrow: "用事实说话",
    proofLine: "16 年。600+ 品牌。",
    proofLineHighlight: "20,000+", proofLineTail: "创意项目。",
    scroll: "向下滚动",
    tags: { brand: "品牌系统", packaging: "包装", digital: "数字产品" },
  },
  cta: {
    eyebrow: "开始项目", title1: "一份简介。一个想法。",
    title2: "一个值得解决的问题。",
    subline: "一日内回复。60分钟通话。",
    start: "开始项目", call: "致电 {{phone}}", book: "预约60分钟会议",
  },
  footer: {
    tagline: "资深主导的设计。全球化的作品。源自班加罗尔。",
    subscribePlaceholder: "您的邮箱 · 关于设计与商业的偶尔来信",
    subscribe: "订阅 →", sending: "发送中",
    explore: "探索", services: "服务", studio: "工作室", social: "社交",
    allServicesLink: "所有服务",
    privacy: "隐私", terms: "条款", sitemap: "网站地图",
    rights: "版权所有。",
  },
  toast: {
    subscribed: "已订阅。我们会与您联系。",
    subscribeError: "无法订阅，请重试。",
    contactSuccess: "感谢。我们将在一个工作日内回复。",
    contactError: "无法发送。请通过邮件或 WhatsApp 联系。",
    invalidEmail: "请输入有效邮箱。",
    fillRequired: "请填写姓名、邮箱和消息。",
  },
  language: { label: "语言", switchTo: "切换语言" },
};

const ja = {
  meta: {
    title: "Ragi | ビジネスを前進させるデザイン。",
    description: "野心的な企業のための、シニア主導のブランディング、デジタル、パッケージデザイン。バンガロールから世界へ。",
  },
  nav: {
    work: "作品", cases: "ケーススタディ", services: "サービス", industries: "業界",
    about: "会社概要", founder: "創業者", insights: "インサイト", contact: "お問い合わせ",
    startProject: "プロジェクト開始", menuOpen: "メニューを開く", menuClose: "メニューを閉じる",
    navigate: "ナビゲート", allServices: "すべてのサービス", allIndustries: "すべての業界",
    studioBengaluru: "スタジオ · バンガロール", call: "電話", whatsapp: "WhatsApp",
    email: "メール", bookMeeting: "60分ミーティング予約",
    signature: "ビジネスを前進させるデザイン。",
  },
  hero: {
    line1: "ビジネスを", line2: "前進させる", line3: "デザイン。",
    eyebrow: "Ragi · バンガロール発",
    subEyebrow: "シニアデザインチーム",
    subline: "ブランド、デジタル、パッケージを、一つのシニアチームが担当します。",
    ctaPrimary: "作品を見る", ctaSecondary: "プロジェクト開始",
    proofEyebrow: "形容詞より事実",
    proofLine: "16年。600+ ブランド。",
    proofLineHighlight: "20,000+", proofLineTail: "クリエイティブ プロジェクト。",
    scroll: "スクロール",
    tags: { brand: "ブランドシステム", packaging: "パッケージ", digital: "デジタル製品" },
  },
  cta: {
    eyebrow: "プロジェクト開始", title1: "ブリーフ。アイデア。",
    title2: "解くべき問題。",
    subline: "1営業日以内に返信。60分の紹介コール。",
    start: "プロジェクト開始", call: "電話 {{phone}}", book: "60分ミーティング予約",
  },
  footer: {
    tagline: "シニア主導のデザイン。グローバルな仕事。バンガロールから。",
    subscribePlaceholder: "メールアドレス · 時々の便り",
    subscribe: "購読 →", sending: "送信中",
    explore: "探す", services: "サービス", studio: "スタジオ", social: "ソーシャル",
    allServicesLink: "すべてのサービス",
    privacy: "プライバシー", terms: "利用規約", sitemap: "サイトマップ",
    rights: "All rights reserved.",
  },
  toast: {
    subscribed: "購読しました。ご連絡します。",
    subscribeError: "購読できませんでした。再試行してください。",
    contactSuccess: "ありがとうございます。1営業日以内に返信します。",
    contactError: "送信できませんでした。メールまたは WhatsApp をお試しください。",
    invalidEmail: "有効なメールを入力してください。",
    fillRequired: "名前、メール、メッセージを入力してください。",
  },
  language: { label: "言語", switchTo: "言語を切り替える" },
};

const ko = {
  meta: {
    title: "Ragi | 비즈니스를 앞으로 나아가게 하는 디자인.",
    description: "야심 찬 기업을 위한 시니어 주도 브랜딩, 디지털, 패키지 디자인. 벵갈루루에서 전 세계로.",
  },
  nav: {
    work: "작업", cases: "사례 연구", services: "서비스", industries: "산업",
    about: "소개", founder: "창립자", insights: "인사이트", contact: "연락처",
    startProject: "프로젝트 시작", menuOpen: "메뉴 열기", menuClose: "메뉴 닫기",
    navigate: "탐색", allServices: "모든 서비스", allIndustries: "모든 산업",
    studioBengaluru: "스튜디오 · 벵갈루루", call: "전화", whatsapp: "WhatsApp",
    email: "이메일", bookMeeting: "60분 미팅 예약",
    signature: "비즈니스를 앞으로 나아가게 하는 디자인.",
  },
  hero: {
    line1: "비즈니스를", line2: "앞으로 나아가게 하는", line3: "디자인.",
    eyebrow: "Ragi · 벵갈루루 설립",
    subEyebrow: "시니어 디자인 팀 하나",
    subline: "브랜드, 디지털, 패키지 디자인을 하나의 시니어 팀이 맡습니다.",
    ctaPrimary: "선정 작업 보기", ctaSecondary: "프로젝트 시작",
    proofEyebrow: "형용사보다 사실",
    proofLine: "16년. 600+ 브랜드.",
    proofLineHighlight: "20,000+", proofLineTail: "크리에이티브 프로젝트.",
    scroll: "스크롤",
    tags: { brand: "브랜드 시스템", packaging: "패키지", digital: "디지털 제품" },
  },
  cta: {
    eyebrow: "프로젝트 시작", title1: "브리프. 아이디어.",
    title2: "풀 만한 문제.",
    subline: "하루 안에 답변. 60분 소개 콜.",
    start: "프로젝트 시작", call: "전화 {{phone}}", book: "60분 미팅 예약",
  },
  footer: {
    tagline: "시니어 주도 디자인. 글로벌 작업. 벵갈루루에서.",
    subscribePlaceholder: "이메일 · 디자인과 비즈니스에 관한 가끔의 편지",
    subscribe: "구독 →", sending: "보내는 중",
    explore: "탐색", services: "서비스", studio: "스튜디오", social: "소셜",
    allServicesLink: "모든 서비스",
    privacy: "개인정보", terms: "약관", sitemap: "사이트맵",
    rights: "All rights reserved.",
  },
  toast: {
    subscribed: "구독했습니다. 연락드리겠습니다.",
    subscribeError: "구독할 수 없습니다. 다시 시도해 주세요.",
    contactSuccess: "감사합니다. 영업일 기준 1일 내 답변드립니다.",
    contactError: "전송할 수 없습니다. 이메일 또는 WhatsApp을 이용해 주세요.",
    invalidEmail: "올바른 이메일을 입력하세요.",
    fillRequired: "이름, 이메일, 메시지를 입력하세요.",
  },
  language: { label: "언어", switchTo: "언어 변경" },
};

const hi = {
  meta: {
    title: "Ragi | डिज़ाइन जो व्यवसाय को आगे बढ़ाए।",
    description: "महत्वाकांक्षी व्यवसायों के लिए सीनियर-नेतृत्व वाली ब्रांडिंग, डिजिटल और पैकेजिंग डिज़ाइन। बेंगलुरु से, दुनिया भर में।",
  },
  nav: {
    work: "काम", cases: "केस स्टडी", services: "सेवाएँ", industries: "उद्योग",
    about: "हमारे बारे में", founder: "संस्थापक", insights: "विचार", contact: "संपर्क",
    startProject: "प्रोजेक्ट शुरू करें", menuOpen: "मेनू खोलें", menuClose: "मेनू बंद करें",
    navigate: "नेविगेट", allServices: "सभी सेवाएँ", allIndustries: "सभी उद्योग",
    studioBengaluru: "स्टूडियो · बेंगलुरु", call: "कॉल", whatsapp: "WhatsApp",
    email: "ईमेल", bookMeeting: "60-मिनट मीटिंग बुक करें",
    signature: "डिज़ाइन जो व्यवसाय को आगे बढ़ाए।",
  },
  hero: {
    line1: "डिज़ाइन जो", line2: "व्यवसाय को", line3: "आगे बढ़ाए।",
    eyebrow: "Ragi · बेंगलुरु में स्थापित",
    subEyebrow: "एक सीनियर डिज़ाइन टीम",
    subline: "ब्रांड, डिजिटल और पैकेजिंग डिज़ाइन, एक ही सीनियर टीम के हाथों।",
    ctaPrimary: "चयनित कार्य देखें", ctaSecondary: "प्रोजेक्ट शुरू करें",
    proofEyebrow: "विशेषण नहीं, तथ्य",
    proofLine: "16 वर्ष। 600+ ब्रांड।",
    proofLineHighlight: "20,000+", proofLineTail: "क्रिएटिव प्रोजेक्ट।",
    scroll: "स्क्रॉल",
    tags: { brand: "ब्रांड सिस्टम", packaging: "पैकेजिंग", digital: "डिजिटल उत्पाद" },
  },
  cta: {
    eyebrow: "प्रोजेक्ट शुरू करें", title1: "एक ब्रीफ। एक विचार।",
    title2: "हल करने योग्य एक समस्या।",
    subline: "एक दिन में जवाब। 60 मिनट की बात।",
    start: "प्रोजेक्ट शुरू करें", call: "कॉल {{phone}}", book: "60-मिनट मीटिंग बुक करें",
  },
  footer: {
    tagline: "सीनियर-नेतृत्व वाली डिज़ाइन। ग्लोबल काम। बेंगलुरु से।",
    subscribePlaceholder: "आपका ईमेल · डिज़ाइन और व्यवसाय पर कभी-कभी पत्र",
    subscribe: "सदस्यता →", sending: "भेज रहे हैं",
    explore: "एक्सप्लोर", services: "सेवाएँ", studio: "स्टूडियो", social: "सोशल",
    allServicesLink: "सभी सेवाएँ",
    privacy: "गोपनीयता", terms: "शर्तें", sitemap: "साइटमैप",
    rights: "सर्वाधिकार सुरक्षित।",
  },
  toast: {
    subscribed: "सदस्यता ली गई। हम संपर्क करेंगे।",
    subscribeError: "अभी सदस्यता नहीं ले सके। पुनः प्रयास करें।",
    contactSuccess: "धन्यवाद। हम एक कार्यदिवस में जवाब देंगे।",
    contactError: "अभी नहीं भेज सके। कृपया ईमेल या WhatsApp आज़माएँ।",
    invalidEmail: "मान्य ईमेल दर्ज करें।",
    fillRequired: "नाम, ईमेल और संदेश भरें।",
  },
  language: { label: "भाषा", switchTo: "भाषा बदलें" },
};

const ru = {
  meta: {
    title: "Ragi | Дизайн, который двигает бизнес.",
    description: "Брендинг, цифровой дизайн и упаковка под руководством сеньоров для амбициозного бизнеса. Из Бангалора по всему миру.",
  },
  nav: {
    work: "Работы", cases: "Кейсы", services: "Услуги", industries: "Отрасли",
    about: "О нас", founder: "Основатель", insights: "Идеи", contact: "Контакты",
    startProject: "Начать проект", menuOpen: "Открыть меню", menuClose: "Закрыть меню",
    navigate: "Навигация", allServices: "Все услуги", allIndustries: "Все отрасли",
    studioBengaluru: "Студия · Бангалор", call: "Позвонить", whatsapp: "WhatsApp",
    email: "Почта", bookMeeting: "Забронировать 60-мин встречу",
    signature: "Дизайн, который двигает бизнес.",
  },
  hero: {
    line1: "Дизайн,", line2: "который двигает", line3: "Бизнес.",
    eyebrow: "Ragi · Основано в Бангалоре",
    subEyebrow: "Одна команда старших дизайнеров",
    subline: "Бренд, цифра и упаковка в руках одной команды старших дизайнеров.",
    ctaPrimary: "Избранные работы", ctaSecondary: "Начать проект",
    proofEyebrow: "Факты, а не эпитеты",
    proofLine: "16 лет. 600+ брендов.",
    proofLineHighlight: "20 000+", proofLineTail: "креативных проектов.",
    scroll: "Скролл",
    tags: { brand: "Бренд-система", packaging: "Упаковка", digital: "Цифровой продукт" },
  },
  cta: {
    eyebrow: "Начать проект", title1: "Бриф. Идея.",
    title2: "Задача, которую стоит решить.",
    subline: "Ответ за день. 60-минутный созвон.",
    start: "Начать проект", call: "Позвонить {{phone}}", book: "Забронировать 60-мин встречу",
  },
  footer: {
    tagline: "Дизайн под руководством сеньоров. Глобальные работы. Из Бангалора.",
    subscribePlaceholder: "Ваш email · редкие письма о дизайне и бизнесе",
    subscribe: "Подписаться →", sending: "Отправка",
    explore: "Исследовать", services: "Услуги", studio: "Студия", social: "Соцсети",
    allServicesLink: "Все услуги",
    privacy: "Конфиденциальность", terms: "Условия", sitemap: "Карта сайта",
    rights: "Все права защищены.",
  },
  toast: {
    subscribed: "Вы подписаны. Мы свяжемся.",
    subscribeError: "Не удалось подписаться. Попробуйте снова.",
    contactSuccess: "Спасибо. Ответим в течение рабочего дня.",
    contactError: "Не удалось отправить. Попробуйте email или WhatsApp.",
    invalidEmail: "Введите корректный email.",
    fillRequired: "Заполните имя, email и сообщение.",
  },
  language: { label: "Язык", switchTo: "Сменить язык" },
};

export const RESOURCES = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  de: { translation: de },
  pt: { translation: pt },
  it: { translation: it },
  ar: { translation: ar },
  zh: { translation: zh },
  ja: { translation: ja },
  ko: { translation: ko },
  hi: { translation: hi },
  ru: { translation: ru },
};

export const LANGUAGES = [
  { code: "en", label: "English", native: "English" },
  { code: "es", label: "Spanish", native: "Español" },
  { code: "fr", label: "French", native: "Français" },
  { code: "de", label: "German", native: "Deutsch" },
  { code: "pt", label: "Portuguese", native: "Português" },
  { code: "it", label: "Italian", native: "Italiano" },
  { code: "ar", label: "Arabic", native: "العربية", rtl: true },
  { code: "zh", label: "Chinese", native: "中文" },
  { code: "ja", label: "Japanese", native: "日本語" },
  { code: "ko", label: "Korean", native: "한국어" },
  { code: "hi", label: "Hindi", native: "हिन्दी" },
  { code: "ru", label: "Russian", native: "Русский" },
];
